import mount from "utils/mount";

import Login from "screens/account/login";

mount(Login);
